import {
  getDistanceCost,
  getHalfHourIntervalTimeCost,
  getHourlyIntervalTimeCost,
} from '../utils';
import {
  isLegacyPricing,
  LEGACY_ERRANDS_FIRST_HOUR_COST,
  LEGACY_ERRANDS_SUBSEQUENT_PRICE_PER_HALF_HOUR,
} from '../constants';
import { CalculationData, CalculationStrategy } from './calculation-strategy';

export class CaregivingErrandsStrategy implements CalculationStrategy {
  calculate(data: CalculationData) {
    // Current (post-cutoff): errands use the SAME tiered step table as
    // caregiving (18€ hours 1-6, 16€ from hour 7; half-hour = ½ of the next
    // hour). Legacy (pre-cutoff, true pre-refactor production formula —
    // verified against commit 4af7d5f^): a standalone formula, unrelated to
    // the hourly table — flat LEGACY_ERRANDS_FIRST_HOUR_COST for the first
    // hour, plus LEGACY_ERRANDS_SUBSEQUENT_PRICE_PER_HALF_HOUR per half-hour
    // beyond that, computed on the RAW (unrounded) duration.
    if (!data?.travel) {
      throw new Error('Travel data is required');
    }

    if (
      !data?.caregivingDuration &&
      typeof data.caregivingDuration !== 'number'
    ) {
      throw new Error('Caregiving duration is required');
    }

    const travelDistance = data.travel.getTravelDistance();
    const driverDistance = data.travel.getDriverDistance();

    const timeCost = isLegacyPricing(data.reservationCreationDate)
      ? LEGACY_ERRANDS_FIRST_HOUR_COST +
        getHalfHourIntervalTimeCost(
          (data.caregivingDuration > 1 ? data.caregivingDuration - 1 : 0) * 2,
          LEGACY_ERRANDS_SUBSEQUENT_PRICE_PER_HALF_HOUR
        )
      : getHourlyIntervalTimeCost(
          data.caregivingDuration,
          18,
          data.reservationCreationDate
        );

    // Don't calculate distance cost if it's lower than 3 kms in one way
    // Distance is calculated 2 ways (from A to B and from B to A)
    const distanceCost =
      travelDistance <= 3
        ? 0
        : getDistanceCost(
            travelDistance * 2 + driverDistance,
            undefined,
            data.reservationCreationDate
          );

    const total = timeCost + distanceCost;

    return {
      timeCost,
      distanceCost,
      totalCost: total,
      driverDistance,
      travelDistance,
    };
  }
}
